import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import CardSummaryItem from '../CardSummaryItem/CardSummaryItem'
import DetailsItem from '../../../components/DetailsItem/DetailsItem'
import { mapRecipientSummary } from '../../../helpers'
import { OptionalSmsSection } from '../OptionalSmsSection/OptionalSmsSection'

const RewardsLinkSummary = ({
  onBack = () => {},
  onSubmit = () => {},
  currentBalance,
  formState,
  isLoading,
  setFormState = () => {},
}) => {
  const { t } = useTranslation(['rewards-gift', 'common'])
  const balanceAfterPayment = currentBalance - (formState.customCardValue ?? formState.cardValue)
  const optionalSmsFieldsValid = formState.sendSms
    ? formState.nonResident
      ? formState.recipientPhone?.length === 10
      : true
    : true

  return (
    <div>
      <div className="rewards-modal-content rewards-base-view custom-card-summary">
        <div className="card-summary-container">
          <CardSummaryItem {...formState} type="link" />
          {(formState.message || formState.note) && (
            <div className="card-summary-description">
              {formState.message && (
                <div className="card-summary-description__item">
                  <span>{t('rewards-gift:sendGiftForm.messageToRecipientLabel')}</span>
                  <span>{formState.message}</span>
                </div>
              )}
              {formState.note && (
                <div className="card-summary-description__item">
                  <span>{t('rewards-gift:sendGiftForm.internalNoteLabel')}</span>
                  <span>{formState.note}</span>
                </div>
              )}
            </div>
          )}
          <OptionalSmsSection formState={formState} setFormState={setFormState} />
        </div>
        <div className="recipient-summary-container">
          <DetailsItem
            data={mapRecipientSummary({ ...formState }, t)}
            title={t('rewards-gift:sendGiftSummary.recipientSummaryTitle')}
          />
          <div className="recipient-divider" />
          {balanceAfterPayment >= 0 ? (
            <React.Fragment>
              <span className="card-summary-title">
                {t('rewards-gift:sendGiftSummary.balanceTitle')}
              </span>
              <table className="recipient-summary-balance-table">
                <thead>
                  <tr>
                    <th>{t('rewards-gift:sendGiftSummary.currentBalanceHeader')}</th>
                    <th>{t('rewards-gift:sendGiftSummary.balanceAfterSendingGiftHeader')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>$ {currentBalance}</td>
                    <td>$ {balanceAfterPayment}</td>
                  </tr>
                </tbody>
              </table>
            </React.Fragment>
          ) : (
            <div className="insufficient-funds">
              <span>{t('rewards-gift:rewardLink.insufficientAccountBalanceInfo')}</span>
              <span>{t('rewards-gift:sendGiftSummary.addFundsToProceedInfo')}</span>
              <span>
                {t('rewards-gift:sendGiftSummary.currentBalanceLabel')} <b>${currentBalance}</b>
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="rewards-modal-actions">
        <button className="button button-gray" onClick={onBack}>
          {t('common:actions.back')}
        </button>
        <button
          className="button button-primary"
          onClick={onSubmit}
          disabled={balanceAfterPayment < 0 || !optionalSmsFieldsValid || isLoading}
        >
          {t('rewards-gift:sendGiftSummary.sendGiftCardButton')}
        </button>
      </div>
    </div>
  )
}

RewardsLinkSummary.propTypes = {
  onBack: PropTypes.func,
  onSubmit: PropTypes.func,
  setFormState: PropTypes.func,
  formState: PropTypes.object,
  isLoading: PropTypes.bool,
  currentBalance: PropTypes.number,
}

export default RewardsLinkSummary
